import React, { ChangeEvent } from 'react';
import { Checkbox } from '@mui/material';
import { LbFormControlLabel } from '@infoods/lifebase-ui';

import classes from './TermsAcceptCheckbox.module.scss';
import { TermsLinks } from '../TermsLinks/TermsLinks';

type TermsAcceptCheckboxProps = {
  isMarketingAccepted: boolean;
  isCommunicationsAccepted: boolean;
  setIsCommunicationsAccepted: (value: boolean) => void;
  setIsMarketingAccepted: (value: boolean) => void;
  entityName?: string | null;
};

const TermsAcceptCheckbox = ({
  isMarketingAccepted,
  isCommunicationsAccepted,
  setIsCommunicationsAccepted,
  setIsMarketingAccepted,
  entityName,
}: TermsAcceptCheckboxProps) => {
  const entityInfoText = entityName || "it's affiliated entities and coaches";

  const handleCommunicationsChange = (
    event: ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) => {
    setIsCommunicationsAccepted(checked);
  };

  const handleMarketingChange = (
    event: ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) => {
    setIsMarketingAccepted(checked);
  };

  return (
    <div className={classes.terms}>
      <LbFormControlLabel
        label={`I consent to receive marketing text messages from LifeBase Solutions and ${entityInfoText} at the phone number provided. Frequency may vary. Message & data rates may apply. Text HELP for assistance, reply STOP to opt out.`}
        control={
          <Checkbox
            checked={isMarketingAccepted}
            onChange={handleMarketingChange}
            color="primary"
          />
        }
      />
      <LbFormControlLabel
        label={`I consent to receive non-marketing text messages from LifeBase Solutions and ${entityInfoText} about my order updates, appointment reminders, etc. Message and data rates may apply.`}
        control={
          <Checkbox
            checked={isCommunicationsAccepted}
            onChange={handleCommunicationsChange}
            color="primary"
          />
        }
      />
      <TermsLinks />
    </div>
  );
};

export { TermsAcceptCheckbox, TermsAcceptCheckboxProps };
